import { useParams } from "react-router-dom";
import SEO from "../../components/seo";
import LayoutTwo from "../../layouts/LayoutTwo";
import { useFetchData } from "../../helpers/api";
import Cookies from "js-cookie";
import LoadingScreen from "../../components/loading/LoadingScreen";
import Breadcrumb from "../../wrappers/breadcrumb/Breadcrumb";
import OrderDetailItem from "./OrderDetailItem";

const customerId = Cookies.get("kalista-web-Id");

const OrderDetail = () => {
  let { id } = useParams();

  const { data: singleOrderData, isLoading } = useFetchData(
    ["singleOrderData"],
    "/Customer/getOrderDetail",
    { OrderId: id },
    id,
    { enabled: !!customerId }
  );
  // const { data: processDetailsData, isLoadingDetails } = useFetchData(
  //   ["processDetailsData"],
  //   "/Customer/OrderProcessDetail",
  //   { OrderId: id },
  //   id,
  //   { enabled: !!customerId }
  // );
  return (
    <>
      <SEO titleTemplate="Order Detail Page" description="Order Detail page" />
      <LayoutTwo>
        {singleOrderData?.Data && (
          <Breadcrumb
            pages={[
              { label: "Home", path: "/" },
              {
                label: "My Orders",
                path: "/orders",
              },
              {
                label: "#" + singleOrderData.Data?.OrderNo || "",
                path: "#",
              },
            ]}
          />
        )}
        {isLoading ? (
          <LoadingScreen />
        ) : singleOrderData?.Data ? (
          <section className="order_details_page">
            <div className="order_left_side">
              <p className="order_number">
                <span>Order Number #</span>
                <span>{singleOrderData.Data.OrderNo}</span>
              </p>
              <p className="order_date">
                {new Intl.DateTimeFormat("en-US", {
                  weekday: "short",
                  month: "short",
                  day: "2-digit",
                  year: "numeric",
                }).format(
                  new Date(
                    parseInt(singleOrderData.Data.OrderDate.match(/\d+/)[0])
                  )
                )}
              </p>
              <div className="order_card">
                <div className="deatails_con">
                  <span>Name:</span>
                  <span>{singleOrderData.Data.CustomerName}</span>
                </div>
                <div className="deatails_con">
                  <span>Sales Person:</span>
                  <span>{singleOrderData.Data.SalesPersonName}</span>
                </div>
                <div className="deatails_con">
                  <span>Labour Amount:</span>
                  <span>{singleOrderData.Data.Amount || 0}</span>
                </div>
                <div className="deatails_con">
                  <span>Billing Type:</span>
                  <span>{singleOrderData.Data.BillingType}</span>
                </div>
              </div>
            </div>
            <div className="order_right_side">
              <OrderDetailItem data={singleOrderData.Data.ListOrderDetail} />
            </div>
          </section>
        ) : (
          <section className="order_details_page">
            <p>No order details available</p>
          </section>
        )}
      </LayoutTwo>
    </>
  );
};

export default OrderDetail;
